module.exports = __webpack_public_path__ + "img/home02.8749e18f.svg";